import React from "react";

const FloatOut = ({ children, style = {} }) => {
  const divStyle = {
    paddingBottom: 8,
    position: "absolute",
    marginTop: -32,
    right: 0,
    marginRight: 30,
    ...style
  };
  return (
    <div className="hidden-sm" style={divStyle}>
      {children}
    </div>
  )
}

export default FloatOut;